<template>
  <div :class="['tabs',{'tabs-collapse':isCollapse}]">
    <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" @select="handleSel" :collapse="isCollapse"
    background-color="rgb(48, 65, 86)" text-color="rgb(191, 203, 217)" active-text-color="rgb(64, 158, 255)" :collapse-transition="false">
      <div v-for="(item,index) in tabArr" :key="index">
        <el-submenu :index="String(index+1)" v-if="item.childFlag">
          <template slot="title">
            <i :class="['iconfont',item.icon]"></i>
            <span class="ml10" slot="title" v-if="!isCollapse">{{item.name}}</span>
          </template>
          <el-menu-item-group>
            <el-menu-item v-show="itemChild.index != '2-4'" :index="itemChild.index" v-for="(itemChild,indexChild) in item.tabChild" :key="indexChild">{{itemChild.content}}</el-menu-item>
            <!-- <el-menu-item :index="itemChild.index" v-for="(itemChild,indexChild) in item.tabChild" :key="indexChild">{{itemChild.content}}</el-menu-item> -->
          </el-menu-item-group>
        </el-submenu>
        <el-menu-item :index="String(index+1)" v-else>
          <i :class="['iconfont',item.icon]"></i>
          <span slot="title">{{item.name}}</span>
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>

<script>
import * as storage from "@/utils/sessionStorage";
import {isObjectEqual} from '@/utils/check'
export default {
  props:{
    isCollapse:{
      type:Boolean,
      value:true
    }
  },
  data() {
    return {
      activeIndex: storage.getData('meunIndex') ? storage.getData('meunIndex') : '1-1',
      // activeIndex: '',
      closeFlag: false,
      tabArr: [
        {
            name: "菜品库管理",
            icon:"icon-data",
            childFlag: true,
            tabChild: [
                { index: "1-1", content: "菜品列表", routerData: "FoodList" }
            ]
        },
        {
            name: "主体管理",
            icon:"icon-subject",
            childFlag: true,
            tabChild: [
                { index: "2-1", content: "同步绑定", routerData: "SyncBind" },
                { index: "2-2", content: "主体管理", routerData: "SubjectManage" },
                { index: "2-3", content: "点餐码解析", routerData: "OrderingCodes" },
                // { index: "2-3", content: "主体添加", routerData: "SubjectAdd" },
                // { index: "2-4", content: "主体详情", routerData: "SubjectDetail" },
            ]
        },
        {
            name: "开通城市管理",
            icon:"icon-city",
            childFlag: true,
            tabChild: [
                { index: "3-1", content: "开通城市列表", routerData: "OpenCityList" }
            ]
        },
        {
            name: "APP版本管理",
            icon:"icon-version",
            childFlag: true,
            tabChild: [
                { index: "4-1", content: "版本列表", routerData: "VersionList" },
            ]
        },
        {
            name: "系统访问配置",
            icon:"icon--",
            childFlag: true,
            tabChild: [
                { index: "5-1", content: "配置列表", routerData: "ConfigList" },
                { index: "5-2", content: "快捷评论配置", routerData: "CommentSetting" },
                { index: "5-3", content: "功能集管理", routerData: "ModuleList" },
                { index: "5-4", content: "首页配置", routerData: "HomeConfigList" }
            ]
        },
        {
          name: "省平台数据绑定",
          icon:"icon-province",
          childFlag: true,
          tabChild: [
            { index: "6-1", content: "校区绑定", routerData: "CompusList" },
            { index: "6-2", content: "食堂绑定", routerData: "DiningRoomList" },
            { index: "6-3", content: "人员绑定", routerData: "UserList" },
            { index: "6-4", content: "供应商绑定", routerData: "SupplierList" }
          ]
        }
        // {
        //     name: "运营账号管理",
        //     icon:"icon-account",
        //     childFlag: true,
        //     tabChild: [
        //         { index: "6-1", content: "运营账号列表", routerData: "AccountList" },
        //     ]
        // }
      ],
      routeArr: storage.getData('routeArr') ? JSON.parse(storage.getData('routeArr')) : []
    };
  },
    mounted() {
        
    },

  methods: {
    handleOpen(key, keyPath) {},

    handleClose(key, keyPath) {},

    handleSel(key, keyPath) {
      storage.setData('meunIndex', key);
      if (keyPath.length==1) {
        this.$router.push({ path: "/"+this.tabArr[key-1].routerData });
        //贮存routeObj值
        this.pushRoute({ name:this.tabArr[key-1].name, 
                         routerData:this.tabArr[key-1].routerData,
                         index: this.tabArr[key-1].name, 
                         superName: this.tabArr[parseInt(key) - 1].name, 
                         type: "info"});
        storage.setData('presentRoute', [this.tabArr[key-1].name])
        this.$emit('presentRoute',[this.tabArr[key-1].name]);
      } else {
        this.tabArr[keyPath[0] - 1].tabChild.forEach(item => {
          if (item.index == keyPath[1]){
            this.pushRoute({ name:item.content,
                             routerData:item.routerData, 
                             index: item.index, 
                             superName: this.tabArr[keyPath[0] - 1].name, 
                             type: "info"});
            this.$router.push({ path: "/" + item.routerData });
            storage.setData('presentRoute', [this.tabArr[keyPath[0] - 1].name, item.content])
            this.$emit('presentRoute',[this.tabArr[keyPath[0] - 1].name, item.content]);
          }
        });
      }
    },
    changeTabs() {
      this.isCollapse ? (this.closeFlag = false) : (this.closeFlag = true);
      this.isCollapse = !this.isCollapse;
    },

    /**
     * 将页面改变的路由路径和名称放入数组
     * routeObj是一个对象,有name和routeData属性
     */ 
    pushRoute(routeObj){
      let routeFlag=this.routeArr.some((item,index)=>{
        let flag=isObjectEqual(item,routeObj);
        return flag;
      });
      if(!routeFlag) this.routeArr.push(routeObj);
      storage.setData('routeArr',JSON.stringify(this.routeArr));
      this.$emit('tabsRoute',this.routeArr);
    }
  }
};
</script>


<style lang="scss">
/*覆盖组件样式*/
.el-menu-vertical-demo {
  height: 600px;
  width: 54px;
  text-align: left;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
}
.el-menu-item:hover,.el-submenu__title:hover{
  background-color: #1f2d3d!important;
}
.el-menu-item-group__title{
  display:none;
}

.tabs {
  .open-tabs {
    width: 180px;
    height: 56px;
    line-height: 56px;
    text-align: left;
    color: rgb(191, 203, 217);
    background-color: rgb(48, 65, 86);
    padding-left: 10px;
    cursor: pointer;
  }
  .close-tabs {
    width: 34px;
  }
  .tabs-content {
    margin-left: 10px;
  }
}
</style>